import React from 'react';
import PropTypes from 'prop-types';

import PaymentMethodItem from 'components/ClientProfile/Payment/Deposit/PaymentMethodItem';

const PaymentListItem = ({
  amount,
  methodAsLink = false,
  operation,
  payment,
  showAmount,
  to = null,
}) => {
  return (
    <PaymentMethodItem
      amount={amount}
      methodAsLink={methodAsLink}
      operation={operation}
      paymentMethod={payment}
      showAmount={showAmount}
      to={to}
    />
  );
};

PaymentListItem.propTypes = {
  amount: PropTypes.string,
  payment: PropTypes.object.isRequired,
  showAmount: PropTypes.bool,
  to: PropTypes.string,
};

export default PaymentListItem;
